import { motion } from "framer-motion";
import { Workflow, UserRound, Gem, Layers } from "lucide-react";
import { TRUST_ITEMS } from "@/lib/constants";

const ICONS = { Workflow, UserRound, Gem, Layers };

export default function TrustStrip() {
  return (
    <section data-testid="trust-strip" className="relative bg-[#0a0a09] border-y border-[#c9a14a]/15">
      <div className="max-w-[1480px] mx-auto px-5 md:px-10 py-8 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-y-8">
        {TRUST_ITEMS.map((item, i) => {
          const Icon = ICONS[item.icon];
          return (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
              data-testid={`trust-item-${i}`}
              className={`flex items-center gap-4 px-2 xl:px-8 ${
                i > 0 ? "xl:border-l xl:border-[#c9a14a]/15" : ""
              }`}
            >
              <span className="w-11 h-11 shrink-0 rounded-full border border-[#c9a14a]/50 flex items-center justify-center text-[#c9a14a]">
                <Icon size={19} strokeWidth={1.5} />
              </span>
              <div>
                {item.numeric ? (
                  <p className="font-numeric text-3xl leading-none text-[#c9a14a]">{item.title}</p>
                ) : (
                  <p className="text-[13px] font-semibold tracking-[0.14em] uppercase text-[#c9a14a] leading-snug">
                    {item.title}
                  </p>
                )}
                <p className="mt-1.5 text-[12px] text-[#f7f2e8]/70 leading-snug max-w-[200px]">
                  {item.sub}
                </p>
              </div>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
